<template>
  <div style="padding: 10px">
    <x-table
      ref="list"
      listApi="biz.warehouse.payment.refund.list"
      paginationLayout="total, sizes, prev, next, jumper"
      actionFixed="right"
      emptyLabel="暂无退款记录信息"
      :fieldList="fieldList"
      :actionList="actionList"
      :defaultParams="defaultParams"
      :actionWidth="160"
    >
      <template slot="row-info" slot-scope="scope">
        <warehouse-payment-refund :refundInfo="scope.row" />
      </template>
    </x-table>
  </div>
</template>

<script>
import timeRange from '../../../../components/timeRange.vue';
import warehousePaymentRefund from '../../../../components/business/warehousePaymentRefund.vue';

export default {
  components: {
    timeRange,
    warehousePaymentRefund,
  },
  props: {
    tabName: {
      type: String,
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    defaultParams() {
      return {
        bizId: this.pageQuery.bizId,
        storeGuid: this.pageQuery.storeGuid,
      };
    },
    pageParams() {
      return Object.assign(
        {},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign(
        {},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
  },
  data() {
    return {
      fieldList: [
        {
          label: "退款信息",
          minWidth: '280',
          slot: "info",
        },
      ],
      actionList: [
      ],
    };
  },
};
</script>